import jStat from 'jstat';

export interface ModeResult {
  modes: number[];
  frequencies: { [key: number]: number };
  data: number[];
  interpretation: string;
}

export function calculateMode(data: number[]): ModeResult {
  // Count frequencies
  const frequencies: { [key: number]: number } = {};
  data.forEach(value => {
    frequencies[value] = (frequencies[value] || 0) + 1;
  });

  // Find the highest frequency
  const maxFrequency = Math.max(...Object.values(frequencies));
  
  // Find all values that appear with the highest frequency
  const modes = Object.entries(frequencies)
    .filter(([_, freq]) => freq === maxFrequency)
    .map(([value, _]) => Number(value))
    .sort((a, b) => a - b);

  let interpretation: string;
  if (modes.length === 1) {
    interpretation = `The data has a single mode at ${modes[0]}, appearing ${maxFrequency} times.`;
  } else if (modes.length === 2) {
    interpretation = `The data is bimodal with modes at ${modes.join(' and ')}.`;
  } else if (modes.length > 2) {
    interpretation = `The data is multimodal with ${modes.length} modes.`;
  } else {
    interpretation = 'The data has no mode (all values appear equally often).';
  }

  return {
    modes,
    frequencies,
    data: [...data].sort((a, b) => a - b),
    interpretation
  };
} 